/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-10 13:57:07 */

const Keys = {
  details: 'details',
  title: 'title',
  close: 'close',
  departure: 'departure',
  arrival: 'arrival',
  cabinClass: {
    economy: 'cabinClass.economy',
    premiumEconomy: 'cabinClass.premiumEconomy',
    business: 'cabinClass.business',
    first: 'cabinClass.first'
  }
}; export default Keys;